export default "__VITE_ASSET__DaB5wXRJ__"